<template>
  <div v-if="!destroyed"
       :id="$attrs['id']"
       :class="[{'hide': !visible}]"
       class="wizard__backdrop"
       @click="onClickOutside()">
    <div class="wizard__content" @click="$event.stopPropagation();">
      <hm-col :grid="true" cols="12">
        <card :min-height="minHeight"
              :header="false"
              title="-"
              cols="12"
              guide="none">
          <hm-card-inner :full-size="true" :style="`--steps: ${steps.length}`" class="wizard__steps__wrapper">
            <div class="wizard__steps">
              <template v-for="(step, idx) in steps">
                <div :class="[{ 'wizard__step--complete': (idx + 1) < activeStep }, { 'wizard__step--active': (idx + 1) === activeStep }]" class="wizard__step">
                  <div class="wizard__step__nr">{{ (idx + 1) }}</div>
                  <span>{{ step }}</span>
                </div>
                <div v-if="(idx+1) < steps.length" class="wizard__step__line"></div>
              </template>
            </div>
            <!--            <div class="wizard__header__btn wizard__header__btn&#45;&#45;close">-->
            <!--              <input-icon-button icon="close" @click="onClickCancel" />-->
            <!--            </div>-->
          </hm-card-inner>
          <hm-card-inner>
            <slot :active-step.sync="activeStep" :change-step="changeStep" />
          </hm-card-inner>
          <hm-card-inner>
            <slot :active-step.sync="activeStep" :steps="steps.length" :change-step="changeStep" name="buttons">

            </slot>
          </hm-card-inner>
        </card>
      </hm-col>
    </div>
  </div>
</template>

<script>

import { isEmpty, isNil, throttle, isFunction } from 'lodash';
import HotelmeisterMixin from '../../../mixins/HotelmeisterMixin';
import TimerMixin from '../../../mixins/TimerMixin';
import HmCardInner from '../layout/HmCardInner';

export default {
  name: 'Wizard',
  components: { HmCardInner },
  mixins: [HotelmeisterMixin, TimerMixin],

  props: {
    closeOnClickOutside: {
      type: Boolean,
      default: false,
    },
    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
    minHeight: {
      type: String,
      required: false,
      default: '100px',
    },
  },

  data() {
    return {
      visible: true,
      destroyed: false,
      throttledOnClickCancel: throttle(this.onClickCancel, this.throttle, { leading: true, trailing: false }),
      activeStep: 1,
    };
  },

  computed: {
  },

  mounted: function () {
  },

  created: function () {
    this.$serviceBus.$on('shortcut.esc', this.onClickCancel);
  },

  beforeDestroy() {
    this.$serviceBus.$off('shortcut.esc', this.onClickCancel);
  },

  methods: {
    onClickCancel: function () {
      this.hide();
      this.$emit('cancel');

      this.addUIBreadcrumb(
        'User clicked cancel in wizard',
        {
          title: this.title,
          content: this.content,
        },
      );
    },
    onClickOutside: function () {
      if (this.closeOnClickOutside) {
        this.onClickCancel();
      }
    },
    show: function () {
      this.visible = true;

      this.addUIBreadcrumb(
        'Show wizard',
        {
          title: this.title,
          content: this.content,
        },
      );

      this.$emit('show');
    },
    hide: function () {
      this.visible = false;
      this.setTimeout(() => {
        this.destroyed = true;
        this.$emit('destroy');
      }, 150);

      this.addUIBreadcrumb(
        'Hide wizard',
        {
          title: this.title,
          content: this.content,
        },
      );

      this.$emit('hide');
    },
    changeStep(step) {
      this.activeStep = Math.min(Math.max(1, step), this.steps.length);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .wizard {
    &__steps {
      width: 100%;
      display: grid;
      background-color: $lightgray;
      padding: 2.4rem 1.6rem;
      grid-template-rows: 1fr;
      --calc-steps: calc(var(--steps) - 1);
      grid-template-columns: repeat(var(--calc-steps), min-content 1fr) min-content;
      --circle-size: 4rem;
      overflow: hidden;
      grid-column-start: span 12;

      @media(max-width: 900px) {
        display: flex;
        justify-content: center;
      }
    }
    &__step {
      display: grid;
      grid-template-columns: 1fr;
      grid-auto-rows: max-content;
      justify-content: center;
      justify-items: center;
      span {
        padding-top: 1rem;
        white-space: nowrap;
        text-transform: uppercase;
      }

      @media(max-width: 900px) {
        &:not(.wizard__step--active) {
          display: none;
        }

        &__line {
          display: none;
        }
        &__nr {
          display: none;
        }
      }

      &--active, &--complete {
        .wizard {
          &__step {
            &__nr {
              color: lightgray;

              &:after {
                z-index: -1;
                background-color: $mint;
                border: 1px solid $mint;
              }
            }
          }
        }
        span {
          font-weight: bold;
        }
      }

      &__nr {
        position: relative;
        font-size: 1.5rem;
        height: var(--circle-size);
        width: var(--circle-size);
        line-height: var(--circle-size);
        text-align: center;
        font-weight: bold;
        z-index: 1;
        &:after {
          content: ' ';
          position: absolute;
          border-radius: 50%;
          top: -1px;
          left: 0;
          right: 0;
          bottom: 1px;
          border: 1px solid $text;
        }
      }
      &__line  {
        position: relative;
        overflow: hidden;
        &:after {
          content: ' ';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: var(--circle-size);
          border-bottom: 1px solid $gray;
          transform: translateY(-50%);
        }
      }
    }
    &__backdrop {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0, 0.35);
      z-index: 99999;
      transition: opacity 0.15s ease;
      opacity: 1;
      // backdrop-filter: blur(2px) grayscale(60%);
      backdrop-filter: saturate(90%) blur(2px);
      justify-content: center;
      align-content: center;
      align-items: center;
      justify-items: center;
      display: flex;
    }

    &__content {
      /*
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
       */
      width: clamp(300px, 90%, 90vw);
      max-width: 95vw;
      transition: opacity 0.15s ease;
      opacity: 1;
      max-height: calc(100vh - 6rem - 5rem);
      margin-top: 5rem;

      @media(min-width: 1140px) {
        width: clamp(300px, calc(100vw - 400px), 1200px);
      }

      /deep/ .card {
        box-shadow: 0 6px 30px 0 rgba($black,0.35);
      }

      /deep/ .card__content {
        max-height: calc(90vh - 60px);
        overflow-y: auto;
      }
    }

    &__header__btn {
      height: 4rem;
      width: 4rem;
      position: absolute;
      display: inline-block;
      float: right;
      right: 0;
      top: 0;

      @include icon-color($middlegray);
      @include icon-hover($text);
    }
  }

  .hide {
    opacity: 0!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/lib/util/Wizard.vue